import { LineChart, Youtube } from "lucide-react";

const BTN =
  "flex w-full items-center justify-center gap-2 rounded-md border border-[#1F293D] px-3 py-2 font-mono2 text-[11px] font-bold uppercase tracking-wider text-slate-300 transition-colors sm:w-auto";

/**
 * Liens sortants, jamais de contenu intégré : aucune iframe, donc aucun cookie tiers,
 * aucun consentement à demander, et aucune mise en avant d'un contenu non vérifié.
 *
 * Nom abrégé (« X. Espart ») => aucun des deux liens : les deux recherches sont un
 * cul-de-sac sans le nom réel.
 *
 * Les deux liens n'ont PAS la même condition d'expérience, parce que les deux sites n'ont
 * pas le même contenu (mesuré en production le 24/09/2026 sur 200 fiches) :
 *   - Transfermarkt référence tout joueur sous contrat, même sans une minute jouée => le
 *     nom complet suffit ;
 *   - YouTube n'a de vidéo que s'il a joué => au moins une apparition senior EN CARRIÈRE
 *     (`rookie.apps_basis`, le compteur qui sert déjà à l'éligibilité rookie). Ne jamais
 *     revenir à `apps_season` : ce compteur ne couvre que la saison en cours et vaut 0 sur
 *     99 % des fiches, ce qui masquait le bouton partout.
 */
export function HighlightsLink({ playerName, clubName, nameComplete, careerApps, t, lang }) {
  if (nameComplete === false) return null;
  const hasPlayed = Number(careerApps) >= 1;
  const query = encodeURIComponent([playerName, clubName, "highlights"].filter(Boolean).join(" ").trim());
  const tmQuery = encodeURIComponent((playerName || "").trim());
  const tmDomain = lang === "fr" ? "www.transfermarkt.fr" : "www.transfermarkt.com";
  return (
    <>
      {hasPlayed && (
        <a
          href={`https://www.youtube.com/results?search_query=${query}`}
          target="_blank"
          rel="noopener noreferrer nofollow"
          data-testid="player-youtube-highlights"
          className={`${BTN} hover:border-[#FF0033]/60 hover:text-[#FF4D6A]`}
        >
          <Youtube className="h-3.5 w-3.5" />
          {t("player.youtube_highlights")} ↗
        </a>
      )}
      <a
        href={`https://${tmDomain}/schnellsuche/ergebnis/schnellsuche?query=${tmQuery}`}
        target="_blank"
        rel="noopener noreferrer nofollow"
        data-testid="player-transfermarkt"
        className={`${BTN} hover:border-[#00F0FF]/60 hover:text-[#00F0FF]`}
      >
        <LineChart className="h-3.5 w-3.5" />
        {t("player.transfermarkt")} ↗
      </a>
    </>
  );
}
